export default __webpack_public_path__ + "static/media/1.d31d0620.jpg";